import { User } from '../@types';
import { lead } from '../services/EventLeadService';

const sendEventLead = (identificador: string, usuario?: User) => {
  lead(identificador, usuario).then(() => {
    console.log(`Evento ${identificador} enviado ao RD Station`);
  });
};

export const setClickToLocalStorage = (event: string, identificador: string, usuario?: User) => {
  const events = JSON.parse(localStorage.getItem('eventCounter') as string);

  if (events?.[event] < 9) {
    const eventCounter = events;
    eventCounter[event] += 1;
    localStorage.setItem('eventCounter', JSON.stringify(eventCounter));
  } else if (events?.[event] === 9) {
    sendEventLead(identificador, usuario);
    const eventCounter = events;
    eventCounter[event] = 0;
    localStorage.setItem('eventCounter', JSON.stringify(eventCounter));
  } else {
    let eventCounter;
    if (events) {
      eventCounter = events;
    } else {
      eventCounter = {};
    }
    eventCounter[event] = 1;
    localStorage.setItem('eventCounter', JSON.stringify(eventCounter));
  }
};
